import { DatePipe, NgIf } from "@angular/common";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { BsModalRef } from "ngx-bootstrap/modal";
import { HotToastService } from "@ngneat/hot-toast";
import { Job } from "../jobs-and-tasks/job.model";
import { JobsService } from "../jobs-and-tasks/jobs.service";
import moment from "moment";
import { DatePickerModule } from "primeng/datepicker";
import { TypeaheadModule } from "ngx-bootstrap/typeahead";
@Component({
  selector: "job-picker-modal",
  templateUrl: "./job-picker-modal.component.html",
  styleUrls: ["./job-picker-modal.component.scss"],
  imports: [
    NgIf,
    FormsModule,
    ReactiveFormsModule,
    TypeaheadModule,
    DatePickerModule,
  ],
})
export class JobPickerModalComponent implements OnInit {
  @ViewChild("templateListInput") public templateListInput: ElementRef;

  selectedJobTemplate: Job;
  templates = [];
  templatesCtrl = new FormControl();
  templatesForm = new FormGroup({
    templates: this.templatesCtrl,
  });

  conversations = [];
  batchSent = false;

  datepickerFormat = "mm-dd-yy";

  jobDueDate: any = moment(new Date(), "MM-DD-YYYY");
  jobStartDate: any = moment(new Date(), "MM-DD-YYYY");

  constructor(
    public bsModalRef: BsModalRef,
    private jobsService: JobsService,
    public toastr: HotToastService,
    private datePipe: DatePipe,
  ) {}

  ngOnInit(): void {
    this.batchSent = false;
    this.jobsService.getJobTemplates("all").subscribe((res) => {
      console.log("THE TEMPLATES", res);
      this.templates = <Array<Job>>res.jobs;
    });
  }

  typeaheadOnSelect(event: any) {
    this.selectedJobTemplate = event.item;
  }

  createJobs() {
    // despite the name, these are CLIENT COMPANIES.
    // C L I E N T  C O M P A N I E S !
    const clientCompanies = this.conversations.map((c) => {
      return {
        clientCompanyId: c.conversationId,
        clientCompanyName: c.conversationName,
      };
    });

    this.selectedJobTemplate.due_date = this.jobDueDate;
    this.selectedJobTemplate.target_start_date = this.jobStartDate;
    console.log(this.selectedJobTemplate.target_start_date);
    console.log(this.selectedJobTemplate.due_date);
    this.jobsService
      .createJobs(clientCompanies, this.selectedJobTemplate)
      .then((res) => {
        this.batchSent = true;
        this.toastr.success(res.message);
      })
      .catch((err) => this.toastr.error(err.error.message));
  }
}
